export enum VDShowType{
    Always = 1,
    OnHover = 2,
    OnFocus = 3,
    OnHoverFocus = 4
}



// WEBPACK FOOTER //
// ./src/app/shared/models/v-d-show-type.ts